import { createSlice } from "@reduxjs/toolkit";
import {
  AddLanguageAction,
  DeleteLanguageAction,
  GetAllLanguagesAction,
  UpdateLanguageAction,
  UpdateDefaultLanguageAction,
} from "store/middlewares/dataManagement/language";

export const languagesSlice = createSlice({
  name: "language",
  initialState: {
    languagesLoading: true,
    languages: null,
    languagesFilterProps: {},
  },
  reducers: {
    setLanguagesFilterProps: (state, action) => {
      state.languagesFilterProps = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllLanguagesAction.pending, (state) => {
        // state.languagesLoading = true;
        // state.languages = null;
        state.languages =
          state.languages?.data?.length > 0 ? state.languages : null;
      })
      .addCase(GetAllLanguagesAction.fulfilled, (state, action) => {
        state.languagesLoading = false;
        state.languages = action.payload.response;
      })
      .addCase(GetAllLanguagesAction.rejected, (state) => {
        state.languagesLoading = false;
        state.languages = null;
      })

      // Delete language
      .addCase(DeleteLanguageAction.fulfilled, (state, action) => {
        state.languagesLoading = false;
        state.languages = {
          ...state.languages,
          total: Number(state.languages.total) - 1,
          data: state.languages?.data?.filter(
            (item) => item.id !== action.payload.id
          ),
        };
      })

      //Update language
      .addCase(UpdateLanguageAction.fulfilled, (state, action) => {
        state.languagesLoading = false;
        state.languages = {
          ...state.languages,
          data: state.languages.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })
      //default
      .addCase(UpdateDefaultLanguageAction.fulfilled, (state, action) => {
        state.languagesLoading = false;
        state.languages = {
          ...state.languages,
          data: state.languages.data.map((reason) =>
            reason.id === action.payload.response.id
              ? { ...reason, ...action.payload.response }
              : { ...reason, is_default: false }
          ),
        };
      })
      //Add language
      .addCase(AddLanguageAction.fulfilled, (state, action) => {
        // state.languagesLoading = false;
        // state.languages = {
        //   ...state.languages,
        //   total: Number(state.languages.total) + 1,
        //   data: [action.payload.response, ...state.languages.data],
        // };
        state.languagesLoading = false;
        state.languages = action.payload.response;
      });
  },
});

export const { setLanguagesFilterProps } = languagesSlice.actions;

export default languagesSlice.reducer;
